import produce from 'immer'
import { cloneDeep } from 'lodash'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { State, Action } from './types'
import { initEvent, initMeta } from 'Store/common/common.reducer'
import parseErrorMessage from 'helpers/parseErrorMessage'
import { convertMetaData } from 'Store/common/common.function'

const initialState: State = {
  list: {
    data: [],
    meta: cloneDeep(initMeta),
  },
  listEvent: cloneDeep(initEvent),
  actionEvent: cloneDeep(initEvent),
  detail: undefined,
  detailEvent: cloneDeep(initEvent),
  logs: [],
  logsEvent: cloneDeep(initEvent),
  newOrder: undefined,
  posBill: {
    event: cloneDeep(initEvent),
    data: undefined,
  },
  updateTerminalStatusEvent: cloneDeep(initEvent),
  updateOrderAddressEvent: cloneDeep(initEvent),
  updatePaymentTypeEvent: cloneDeep(initEvent),
}

export default function(state: State = initialState, action: Action) {
  return produce(state, draft => {
    let response
    switch (action.type) {
      case getType(actions.getListAction.request):
        draft.listEvent = cloneDeep(initEvent)
        draft.listEvent.IsLoading = true
        draft.list = {
          data: [],
          meta: cloneDeep(initMeta),
        }
        return draft
      case getType(actions.getListAction.success):
        response = action.payload
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitSuccess = true
        draft.list.data = response.data
        if (response.meta) {
          draft.list.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getListAction.failure):
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getDetailAction.request):
        draft.detailEvent = cloneDeep(initEvent)
        draft.detailEvent.IsLoading = true
        draft.detail = undefined
        return draft
      case getType(actions.getDetailAction.success):
        response = action.payload
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitSuccess = true
        draft.detail = response.data
        return draft
      case getType(actions.getDetailAction.failure):
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.updateAction.request):
        draft.actionEvent = cloneDeep(initEvent)
        draft.actionEvent.IsLoading = true
        return draft
      case getType(actions.updateAction.success):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = undefined
        draft.actionEvent.SubmitSuccess = true
        draft.actionEvent.MessageSuccess = 'บันทึกข้อมูลสำเร็จ'
        return draft
      case getType(actions.updateAction.failure):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.createBestTrackingAction.request):
        draft.actionEvent = cloneDeep(initEvent)
        draft.actionEvent.IsLoading = true
        return draft
      case getType(actions.createBestTrackingAction.success):
        return draft
      case getType(actions.createBestTrackingAction.failure):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = 'เกิดข้อผิดพลาดไม่สามารถสร้างหมายเลขการจัดส่งได้'
        return draft
      case getType(actions.getOrderLogsAction.request):
        draft.logsEvent = cloneDeep(initEvent)
        draft.logsEvent.IsLoading = true
        draft.logs = []
        return draft
      case getType(actions.getOrderLogsAction.success):
        response = action.payload
        draft.logsEvent.IsLoading = false
        draft.logsEvent.SubmitSuccess = true
        draft.logs = response.data
        return draft
      case getType(actions.getOrderLogsAction.failure):
        draft.logsEvent.IsLoading = false
        draft.logsEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.countNewOderAction.request):
        draft.newOrder = undefined
        return draft
      case getType(actions.countNewOderAction.success):
        response = action.payload
        draft.newOrder = response.data
        return draft
      case getType(actions.countNewOderAction.failure):
        draft.newOrder = {
          total: 0,
        }
        return draft
      case getType(actions.getPosBillAction.request):
        draft.posBill.data = undefined
        draft.posBill.event = cloneDeep(initEvent)
        draft.posBill.event.IsLoading = true
        return draft
      case getType(actions.getPosBillAction.success):
        response = action.payload
        draft.posBill.data = response.data
        return draft
      case getType(actions.getPosBillAction.failure):
        draft.posBill.event.IsLoading = false
        draft.posBill.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.updateTerminallStatusAutoAction.request):
        draft.updateTerminalStatusEvent = cloneDeep(initEvent)
        draft.updateTerminalStatusEvent.IsLoading = true
        return draft
      case getType(actions.updateTerminallStatusAutoAction.success):
        response = action.payload
        draft.updateTerminalStatusEvent.IsLoading = false
        draft.updateTerminalStatusEvent.SubmitError = undefined
        draft.updateTerminalStatusEvent.SubmitSuccess = true
        draft.updateTerminalStatusEvent.MessageSuccess = response?.message || ''
        return draft
      case getType(actions.updateTerminallStatusAutoAction.failure):
        draft.updateTerminalStatusEvent.IsLoading = false
        draft.updateTerminalStatusEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.updateOrderAddressAction.request):
        draft.updateOrderAddressEvent = cloneDeep(initEvent)
        draft.updateOrderAddressEvent.IsLoading = true
        return draft
      case getType(actions.updateOrderAddressAction.success):
        response = action.payload
        draft.updateOrderAddressEvent.IsLoading = false
        draft.updateOrderAddressEvent.SubmitError = undefined
        draft.updateOrderAddressEvent.SubmitSuccess = true
        draft.updateOrderAddressEvent.MessageSuccess = response?.message || ''
        return draft
      case getType(actions.updateOrderAddressAction.failure):
        draft.updateOrderAddressEvent.IsLoading = false
        draft.updateOrderAddressEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.updatePaymentTypAction.request):
        draft.updatePaymentTypeEvent = cloneDeep(initEvent)
        draft.updatePaymentTypeEvent.IsLoading = true
        return draft
      case getType(actions.updatePaymentTypAction.success):
        response = action.payload
        draft.updatePaymentTypeEvent.IsLoading = false
        draft.updatePaymentTypeEvent.SubmitError = undefined
        draft.updatePaymentTypeEvent.SubmitSuccess = true
        draft.updatePaymentTypeEvent.MessageSuccess = response?.message || ''
        return draft
      case getType(actions.updatePaymentTypAction.failure):
        draft.updatePaymentTypeEvent.IsLoading = false
        draft.updatePaymentTypeEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.clearEventAction):
        draft.listEvent = cloneDeep(initEvent)
        draft.actionEvent = cloneDeep(initEvent)
        draft.posBill.event = cloneDeep(initEvent)
        draft.updateTerminalStatusEvent = cloneDeep(initEvent)
        draft.updateOrderAddressEvent = cloneDeep(initEvent)
        draft.updatePaymentTypeEvent = cloneDeep(initEvent)
        return draft
      default:
        return state
    }
  })
}
